import * as type from './type'
import {get, post} from "../../../../util/api";
import { loadGlobals } from '../../../globals/state/action'
import * as selector from '../../state/detail/selector';

export const createOrUpdateStore = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    const isFetching = selector.selectIsFetching(state)
    if (!hasChanged || isFetching) {
        return
    }
    dispatch(saveStoreRequest())
    const store = selector.selectStore(state)

    post('/api/store/create-update-store', store)
        .then(() => {
            dispatch(saveStoreSuccess())
            dispatch(clearState())
            dispatch(loadGlobals())
        })
        .catch(error => {
            dispatch(saveStoreError(error))
        })
}

export const findStore = (storeId) => (dispatch, getState) => {
    dispatch(findStoreRequest())

    get('/api/store/get-by-id?id=' + storeId)
        .then(store => {
            dispatch(findStoreSuccess(store))
        })
        .catch(error => {
            dispatch(findStoreError(error))
        })
}

export const findStoreRequest = () => ({
    type: type.FIND_STORE_REQUEST,
})

export const findStoreSuccess = (store) => ({
    type: type.FIND_STORE_SUCCESS,
    payload: {
        store
    },
})

export const findStoreError = (error) => ({
    type: type.FIND_STORE_ERROR,
    payload: {
        error
    },
})

export const saveStoreRequest = () => ({
    type: type.SAVE_STORE_REQUEST,
})

export const saveStoreSuccess = () => ({
    type: type.SAVE_STORE_SUCCESS,
})

export const clearState = () => ({
    type: type.CLEAR_STATE,
})

export const saveStoreError = ({validationMessageList}) => ({
    type: type.SAVE_STORE_ERROR,
    payload: {
        validationMessageList
    },
})

export const editFormValue = (name, value) => ({
    type: type.EDIT_STORE,
    payload: {
        name,
        value,
    },
})
export const pushValidationList = (list) => ({
    type: type.VALIDATION_LIST,
    payload: {
        list
    },
})





// WEBPACK FOOTER //
// ./src/modules/store/state/detail/action.js